//@vendor
const get = require('lodash/object/get');
//@utilities
const { APIGet } = require('utilities/APIRequestHelper');
const DateHelper = require('utilities/dateHelper');
//@constants
const actionTypes = require('../loansConstants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');

const setFilters = filters => {
    return {
        type: actionTypes.LOAN_SETTLEMENTS_SET_FILTERS,
        payload: {
            filters
        }
    };
};

const clearFitlers = () => ({type: actionTypes.CLEAR_LOAN_SETTLEMENTS_FILTERS});

const fetchLoanSettlements = loanId => {
    return {
        type: actionTypes.FETCH_LOAN_SETTLEMENTS,
        payload: {
            loanId
        }
    }
};

const fetchLoanSettlementsSuccess = (loanId, response) => {
    return {
        type: actionTypes.FETCH_LOAN_SETTLEMENTS_SUCCESS,
        payload: {
            loanId,
            settlements: get(response, 'liquidaciones.liquidacion', []) || [],
            nextPage: get(response, '_links.nextPage', '') || '',
            paginationData: response.datosPaginacion || {}
        }
    }
};

const fetchLoanSettlementsFailure = (loanId, error) => {
    return {
        type: actionTypes.FETCH_LOAN_SETTLEMENTS_FAILURE,
        payload: {
            loanId,
            error
        }
    }
};

const requestLoanSettlements = loanId => (dispatch, getState) => {
    const immLoan = getState().loans.getIn(['byId', loanId]);
    const immFilters = getState().loanSettlements.get('filters');

    const params = {
        query: {
            producto: immLoan.get('newProduct'),
            numeroContrato: immLoan.get('newContractNumber')
        }
    };

    if (immFilters.get('isActive')) {
        params.query.fechaDesde = DateHelper.formatDate(immFilters.getIn(['date', 'from']), DATE_FORMAT_API);
        params.query.fechaHasta = DateHelper.formatDate(immFilters.getIn(['date', 'to']), DATE_FORMAT_API);
    }

    const config = {
        dispatch,
        endpoint: 'loanSettlements',
        params
    };

    dispatch(fetchLoanSettlements(loanId));
    APIGet(config)
        .then(response => { dispatch(fetchLoanSettlementsSuccess(loanId, response)) })
        .catch((response) => {
            if (!!response.error) {
                dispatch(fetchLoanSettlementsFailure(loanId, response.error));
            } else {
                throw response;
            }
        });
};

const nextPageFailure = error => {
    return {
        type: actionTypes.LOAN_SETTLEMENTS_FETCH_NEXT_PAGE_FAILURE,
        payload: {
            error
        }
    };
};

const nextPageRequest = () => ({
    type: actionTypes.LOAN_SETTLEMENTS_FETCH_NEXT_PAGE
});

const nextPageSuccess = (response, loanId) => {
    return {
        type: actionTypes.LOAN_SETTLEMENTS_FETCH_NEXT_PAGE_SUCCESS,
        payload: {
            loanId,
            nextPage: get(response, '_links.nextPage.href', ''),
            settlements: get(response, 'liquidaciones.liquidacion', []) || []
        }
    };
};

const requestNextPage = loanId => (dispatch, getState) => {
    const nextPageURL = getState().loanSettlements.get('nextPage');

    dispatch(nextPageRequest());
    return APIGet(dispatch, nextPageURL)
        .then(response => dispatch(nextPageSuccess(response, loanId)))
        .catch(response => {
            if (!!response.error) {
                dispatch(nextPageFailure(response.error));
            } else {
                throw response;
            }
        })
};

module.exports = {
    requestNextPage,
    requestLoanSettlements,
    setFilters,
    clearFitlers
};

